import { isEmpty } from 'Utils/object'
import { sessionget } from 'Utils/storage.js'

const travelInfo ={
  namespaced: true,

  state:{//state就是Vuex中的公共的状态, 我是将state看作是所有组件的data, 用于保存所有组件的公共数据.
    costCenter:{}, //成本中心
    project:{}, 	//项目
    travelList:{},  //出差单
    violateList:{}, //违背原因
    subjectCode:{} //科目码
  },
  getters:{//getters属性理解为所有组件的computed属性, 也就是计算属性 
    tkSearchInfo: (state) => {
      if(isEmpty(state.tkSearchInfo)){
        return sessionget('tkSearchInfo')||{}
      }else{
        return this.tkSearchInfo
      }
    }
  },
  mutations:{ //mutaions理解为store中的methods
    costCenter(state, payload){
      state.costCenter=payload
    },
    project(state, payload){
      state.project=payload
    },
    travelList(state, payload){
      state.travelList=payload
    },
    violateList(state, payload){
      state.violateList=payload
    },
    subjectCode(state, payload){
      state.subjectCode=payload
    },
    CLEAR_ALL(state, payload){
      state.costCenter={} //成本中心
      state.project={} 	//项目
      state.travelList={}  //出差单
      state.violateList={} //违背原因
      state.subjectCode={} //科目码
    },
  },
  actions:{ //添加actions actions中可以包含异步操作
    minusPriceAsync( context, payload ) {
      // setTimeout( () => {
      //     context.commit( 'minusPrice', payload ); //context提交
      // }, 2000)
    }
  }
}
export default travelInfo